import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { getTranslationKey } from 'helpers/texting';
import environment from 'environment';
import { Button } from 'modules/ScrShopNew/components/Buttons';
import { useAppSelector, useAppDispatch } from 'hooks/redux';
import { markNewAppModalShown } from 'store/slices/collection/actions';

export const AppUpdateBanner: React.FC = () => {
  const dispatch = useAppDispatch();
  const { isNewAppModalShown } = useAppSelector((state) => state.collection);

  const shouldShow = environment.isAndroidDevice && environment.isStandalone && !isNewAppModalShown;

  if (!shouldShow) return null;

  const handleDismiss = () => dispatch(markNewAppModalShown());

  return (
    <Modal data-cy="app-update-banner" centered isOpen toggle={handleDismiss} zIndex={999999}>
      <ModalHeader>{getTranslationKey('appinstallation.updateBannerTitle')}</ModalHeader>
      <ModalBody>
        <span>{getTranslationKey('appinstallation.updateBanner')}</span>
      </ModalBody>
      <ModalFooter>
        <Button onClick={handleDismiss}>{getTranslationKey('okay')}</Button>
      </ModalFooter>
    </Modal>
  );
};
